<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_EMAIL_TEMPLATE')"
      size="lg"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="emailtemplateform"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="user_type === 'Super Admin'"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_COMPANY_NAME')"
                  label-for="title"
                  class="mb-2"
                >
                  <b-form-input
                    id="title "
                    v-model="details.companyName"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title "
                      v-model="details.name"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_SUBJECT')"
                  label-for="subject"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Subject"
                    rules="required"
                  >
                    <b-form-input
                      id="subject "
                      v-model="details.subject"
                      type="text"
                      :placeholder="$t('DEBTIA_SUBJECT')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TEMPLATE')"
                  label-for="template"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Template"
                    rules="required"
                  >
                    <quill-editor
                      v-model="details.content"
                      :options="snowOption"
                      style="min-height: 150px"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { quillEditor } from 'vue-quill-editor'
import { required } from '@validations'
import axios from '@axios'
// import constants from '@/app-configs/constants'
import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    quillEditor,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    templateData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        subject: '',
        content: '',
        type: 'email',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
        companyName: '',
      },
      templateDetails: {
        type: 'email',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
    }
  },
  watch: {
    templateData: {
      handler() {
        this.details = { ...this.templateData }
      },
    },
  },
  created() {
    this.getCommunicationApiSettings()
  },
  methods: {
    async getCommunicationApiSettings() {
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
        }
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.emailtemplateform.validate().then(success => {
        if (success) {
          let url = ''
          const headers = {
            clientId: this.communication_client_id,
            secret: this.communication_secret,
          }
          if (this.details.id > 0) {
            url = `/template/update-template-api/${this.details.id}`
          } else {
            url = '/template/save-template-api'
          }
          axiosemail.post(url, { ...this.details }, {
            headers,
          }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, name: '', content: '', type: 'email', user_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
.ql-container.ql-snow{
  height: 150px !important;
}
</style>
